export default [
  {
    sessionid: "1101",
    createDate: "26/06/2022",
    mobile: "9892130802",
    name: "sahil.kanerkar",
    gross: "₹2000",
    share: "10%",
    amount: "₹800",
    status: "Unsettled",
  },
  {
    sessionid: "1102",
    createDate: "26/08/2022",
    mobile: "9892130802",
    name: "yash singh",
    gross: "₹2000",
    share: "10%",
    amount: "₹800",
    status: "Unsettled",
  },
  {
    sessionid: "1103",
    createDate: "21/06/2022",
    mobile: "9892130802",
    name: "sumit jaiswal",
    gross: "₹2000",
    share: "10%",
    amount: "₹800",
    status: "Unsettled",
  },
  {
    sessionid: "1103",
    createDate: "16/011/2014",
    mobile: "9892130802",
    name: "ruchita singh",
    gross: "₹2000",
    share: "10%",
    amount: "₹800",
    status: "Unsettled",
  },
];
